'use-client'

import { ReactNode } from 'react'

import {
  Carousel,
  CarouselContent,
  CarouselNext,
  CarouselPrevious,
} from './ui/Carousel.component'

export const CarouselTeam = ({ children }: { children: ReactNode }) => {
  return (
    <div className="relative">
      <Carousel
        opts={{
          align: 'center',
          slidesToScroll: 4,
        }}
        className="w-full"
      >
        <CarouselPrevious />
        <CarouselNext />
        <CarouselContent>{children}</CarouselContent>
      </Carousel>
    </div>
  )
}
